import { ReactElement } from "react"

type PositionDataKpiProps = {
	label: string
	value: number | null
	unit?: string
	width?: number
}

export default function PositionDataKpi({
	label,
	value,
	unit,
	width,
}: PositionDataKpiProps): ReactElement {
	return (
		<div
			className={`grid-rows grid h-12 gap-0 px-2`}
			style={{ width: width !== undefined ? width : "100%" }}
		>
			<p className={`text-dipai-secondary-901 text-title5 text-center font-semibold`}>
				{`${value !== null ? Math.round(10 * value) / 10 : `--`}`}
				<span className={`text-button text-gray-444 pl-1 font-normal`}>{`${
					unit !== undefined ? " " : ""
				}${unit !== undefined ? unit : ""}`}</span>
			</p>
			<p className={`text-tiny text-dipai-secondary-901/90 text-center lowercase`}>{label}</p>
		</div>
	)
}
